import Hashids from 'hashids';

const hashids = new Hashids('usk', 8);

const getHashedId = id => hashids.encode(id);
const getDecodedId = hashedId => hashids.decode(hashedId)[0];

export { getHashedId, getDecodedId };
